/** localStorage that never throws (private mode, blocked storage, sandboxed previews). */
const memory = new Map<string, string>();

export const safeStorage = {
  get(key: string): string | null {
    try {
      const v = window.localStorage.getItem(key);
      if (v !== null) return v;
    } catch {
      /* fall through to memory */
    }
    return memory.get(key) ?? null;
  },
  set(key: string, value: string): void {
    memory.set(key, value);
    try {
      window.localStorage.setItem(key, value);
    } catch {
      /* memory only */
    }
  },
  remove(key: string): void {
    memory.delete(key);
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  },
};

export const TOKEN_KEY = "amr-coach.token";
export const THEME_KEY = "amr-coach.theme";
